"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseJobTypes = void 0;
const job_1 = require("./job");
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
class BaseJobTypes {
}
__decorate([
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], BaseJobTypes.prototype, "jobApiId", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "installation", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "reclamation", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "precheck", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "activation", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "remote", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "hardwareSale", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "maintenance", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "defectElimination", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "planning", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "customerSignRequired", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "asyncAppointment", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)({
        default: false,
    }),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "meterApplication", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], BaseJobTypes.prototype, "installationPreparation", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_1.Job, (job) => job.jobTypes),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], BaseJobTypes.prototype, "job", void 0);
exports.BaseJobTypes = BaseJobTypes;
//# sourceMappingURL=base-job-types.js.map